import Query from '../../components/Report';

const query = (isConfidence) =>
    isConfidence
        ? new Query('discover-categories-view-confidence', { isConfidence })
        : new Query('discover-categories-view');

export default query;
